var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionListExcludeItem({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17H3v2h9v-2Z",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5H3v2h2V5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 5H7v2h14V5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9H3v2h2V9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9H7v2h14V9Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 13h2v2H3v-2Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13h5v2H7v-2Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.293 21.707 18 19.414l-2.293 2.293-1.414-1.414L16.586 18l-2.293-2.293 1.414-1.414L18 16.586l2.293-2.293 1.414 1.414L19.414 18l2.293 2.293-1.414 1.414Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionListExcludeItem);
export default __webpack_public_path__ + "static/media/ic_action_list_exclude_item.d550dd42a601faa73306d3e2659f5996.svg";
export { ForwardRef as ReactComponent };